import React, { useState, useRef, useEffect } from "react";
import {
  XMarkIcon,
  ArrowTopRightOnSquareIcon,
} from "@heroicons/react/16/solid";
import { Button } from "../tailwind/button";
import MultiTagAutocomplete from "../flow_editor/shared/panel/components/MultiTagAutocomplete";
import TagDisplay from "../flow_editor/shared/panel/components/TagDisplay";

const TagContactsPopup = ({
  isOpen,
  onClose,
  contactCount,
  onTagContacts,
  customerId,
  isLoading = false,
}) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const popupRef = useRef(null);

  const handleTagContacts = () => {
    if (selectedTags.length > 0) {
      onTagContacts(selectedTags);
    }
  };

  const handleClose = () => {
    setSelectedTags([]);
    onClose();
  };

  // Handle click outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        ref={popupRef}
        className="bg-white rounded-lg p-6 w-full max-w-md mx-4"
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Tag {contactCount} contact{contactCount !== 1 ? "s" : ""}
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
            type="button"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select tags to add:
          </label>
          <MultiTagAutocomplete
            selectedTags={selectedTags}
            onTagsChange={setSelectedTags}
            customerId={customerId}
          />
          <TagDisplay
            tags={selectedTags}
            onRemoveTag={(tagId) => {
              setSelectedTags(selectedTags.filter((tag) => tag.id !== tagId));
            }}
          />
        </div>

        <div className="flex justify-between items-center">
          <a
            href="/settings/data/tags"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-gray-700 underline flex items-center gap-1"
          >
            Manage tags
            <ArrowTopRightOnSquareIcon className="h-3 w-3" />
          </a>
          <Button
            color="primaryButton"
            onClick={handleTagContacts}
            disabled={selectedTags.length === 0 || isLoading}
          >
            {isLoading
              ? "Tagging..."
              : `Tag ${contactCount} contact${contactCount !== 1 ? "s" : ""}`}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TagContactsPopup;
